import { render, staticRenderFns } from "./layout-fallback.vue?vue&type=template&id=6ca005b5&"
import script from "./layout-fallback.vue?vue&type=script&lang=js&"
export * from "./layout-fallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "layout-fallback.vue"
export default component.exports